import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { TrlFieldDefaultValue } from '»utils/trlFieldDefaultValue';

export const TrlDateFormatted = ({ date, option }) => {
  const intl = useIntl();
  if (!date) return <TrlFieldDefaultValue />;

  if (option === 'time') return intl.formatTime(date);

  const dateFormated = intl.formatDate(date, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  return dateFormated;
};

TrlDateFormatted.propTypes = {
  date: PropTypes.any,
  option: PropTypes.any,
};
